import { writable } from 'svelte/store';

export const academyStore = writable(null);
